import React from 'react';

import { Button } from '@mui/material';
import { useToggle } from 'react-use';

import classes from './NgzSelfBillingPaymentTab.module.scss';
import { SelfBillingPaymentRulesModal } from './SelfBillingPaymentRulesModal/SelfBillingPaymentRulesModal';
import { UserFeesTab } from './UserFeesTab/UserFeesTab';
import { InvoicesTab } from './InvoicesTab/InvoicesTab';
import { EntityType } from '../../../../shared/constants/user-info/ENTITY_TYPES';
import { angularizeWithProviders } from '../../../../shared/providers';
import { PageTitle } from '../../../../shared/components/ui-components';
import {
  LbTabPanel,
  LbTabs,
  LbUnderlineTabsList,
} from '../../../../shared/components/tabs';

type NgzSelfBillingPaymentTabProps = {
  entityId: number;
  entityType: EntityType;
};

const NgzSelfBillingPaymentTab = ({
  entityId,
  entityType,
}: NgzSelfBillingPaymentTabProps) => {
  const [isShowPaymentRules, toggleShowPaymentRules] = useToggle(false);

  const tabsConfig = [
    {
      label: 'User Fees & Free Access',
      value: 0,
      panel: <UserFeesTab entityId={entityId} entityType={entityType} />,
    },
    { label: 'Invoices', value: 1, panel: <InvoicesTab entityId={entityId} /> },
  ];

  return (
    <>
      <LbTabs defaultValue={0}>
        <PageTitle
          title="Payment"
          className={classes.title}
          customTopMargin
          customBottomMargin
          tabs={<LbUnderlineTabsList tabsConfig={tabsConfig} />}
        >
          <Button variant="outlined" size="medium" onClick={toggleShowPaymentRules}>
            Open Payment Rules
          </Button>
        </PageTitle>
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
      <SelfBillingPaymentRulesModal
        open={isShowPaymentRules}
        onClose={toggleShowPaymentRules}
      />
    </>
  );
};

angularizeWithProviders(NgzSelfBillingPaymentTab, 'ngzSelfBillingPaymentTab', {
  entityId: '<',
  entityType: '<',
});
